

class CallbackManager {
  constructor(target) {
    this.id = 0;
    this.callbacks = {};

    if (target) {
      target.subscribe = callback => {
        this.callbacks[++this.id] = callback;
        return this.id;
      };

      target.unsubscribe = id => {
        delete this.callbacks[id];
      }
    }
  }

  update(data) {
    Object.values(this.callbacks).forEach(callback => callback(data));
  }
}


export default CallbackManager;
